import React, { useState } from "react";
import Modal from "react-modal";

// Modal uchun kerakli CSS ni qo‘shish (agar hohlasangiz)
const customStyles = {
    content: {
        top: "50%",
        left: "50%",
        right: "auto",
        bottom: "auto",
        marginRight: "-10%",
        transform: "translate(-50%, -50%)",
        maxWidth: "75%",
        maxHeight: "75%",
        padding: "10px",
        borderRadius: "10px",
        background: "#fff",
        boxShadow: "0px 5px 15px rgba(0,0,0,0.3)",
    },
    overlay: {
        backgroundColor: "rgba(0, 0, 0, 0.7)",
    },
};

const ImageModal = ({ src, alt }) => {
    const [modalIsOpen, setModalIsOpen] = useState(false);

    return (
        <div>
            {/* Kichik rasm */}
            <img
                src={src}
                alt={alt}
                style={{ width: "150px", height: "150px", cursor: "pointer", borderRadius: "8px" }}
                onClick={() => setModalIsOpen(true)}
            />

            {/* Modal */}
            <Modal
                isOpen={modalIsOpen}
                onRequestClose={() => setModalIsOpen(false)}
                style={customStyles}
                ariaHideApp={false} // Bu xatolik oldini oladi
            >
                <button
                    onClick={() => setModalIsOpen(false)}
                    style={{
                        position: "absolute",
                        top: "10px",
                        right: "15px",
                        fontSize: "18px",
                        background: "none",
                        border: "none",
                        cursor: "pointer",
                    }}
                >
                    ✖
                </button>
                <img src={src} alt={alt} style={{ width: "100%", height: "auto", borderRadius: "8px" }} />
            </Modal>
        </div>
    );
};

export default ImageModal;
